class CustomSlider {
	constructor(scroll_container, btn_back, btn_forward) {
		this.scroll_container = scroll_container;
		this.btn_back = btn_back;
		this.btn_forward = btn_forward;

		if (!this.scroll_container || !this.btn_back || !this.btn_forward) return;

        // counter
        this.slides = Array.from(this.scroll_container.querySelectorAll('.block-image-gallery__modal-slide'));
		this.counterEl = this.scroll_container
			.closest('.block-image-gallery__modal-wrapper')
			.querySelector('.modal-counter');

		this.currentIndex = parseInt(this.scroll_container.dataset.startIndex, 10) || 0;
        
        // width to scroll
        let firstSlide = this.slides[0];
		this.SCROLL_AMOUNT = firstSlide ? firstSlide.offsetWidth : 2000;

		this.init();
	}

	init() {
		this.updateButtons();
		this.scrollToStartIndex();

		this.btn_back.addEventListener('click', () => this.scrollBack());
		this.btn_forward.addEventListener('click', () => this.scrollForward());
		
        // Detect scroll updates (manual touch or mouse drag)
		this.scroll_container.addEventListener('scroll', () => {
			this.updateButtons();
			this.updateIndexOnScroll();
		});

		// Update button states and scroll amount on resize
		window.addEventListener('resize', () => {
            const firstSlide = this.slides[0];
            this.SCROLL_AMOUNT = firstSlide ? firstSlide.offsetWidth : 2000;
            this.updateButtons();
        });
	}

	setDisabled(el, isDisabled) {
		el.classList.toggle('disabled', isDisabled);
	}

	updateButtons() {
		const maxScroll = this.scroll_container.scrollWidth - this.scroll_container.clientWidth;
		this.setDisabled(this.btn_back, this.scroll_container.scrollLeft <= 0);
		this.setDisabled(this.btn_forward, this.scroll_container.scrollLeft >= maxScroll);
	}

    updateCounter() {
		if (!this.counterEl) return;
		this.counterEl.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
	}

	updateIndexOnScroll() {
		// Get total scrollable width
		const maxScroll = this.scroll_container.scrollWidth - this.scroll_container.clientWidth;
		const scrollLeft = this.scroll_container.scrollLeft;

		// Compute index using ratio instead of rounding error-prone division
		let newIndex = Math.round((scrollLeft / maxScroll) * (this.slides.length - 1));

		// Clamp index to valid bounds
		newIndex = Math.min(Math.max(newIndex, 0), this.slides.length - 1);

		if (newIndex !== this.currentIndex) {
			this.currentIndex = newIndex;
			this.updateCounter();
		}
	}

	scrollBack() {
        this.currentIndex = Math.max(this.currentIndex - 1, 0);
		const target = Math.max(this.scroll_container.scrollLeft - this.SCROLL_AMOUNT, 0);
		this.scroll_container.scrollTo({ left: target, behavior: 'smooth' });
		this.setDisabled(this.btn_back, target === 0);
		this.setDisabled(this.btn_forward, false);
	}

	scrollForward() {
        this.currentIndex = Math.min(this.currentIndex + 1, this.slides.length - 1);
		const maxScroll = this.scroll_container.scrollWidth - this.scroll_container.clientWidth;
		const target = Math.min(this.scroll_container.scrollLeft + this.SCROLL_AMOUNT, maxScroll);
		this.scroll_container.scrollTo({ left: target, behavior: 'smooth' });
		this.setDisabled(this.btn_forward, target === maxScroll);
		this.setDisabled(this.btn_back, false);
	}

	scrollToStartIndex() {
		const startIndex = parseInt(this.scroll_container.dataset.startIndex, 10);
		if (isNaN(startIndex) || startIndex < 0) return;

        this.currentIndex = startIndex;
		const slides = this.slides;
		const targetSlide = slides[startIndex];
		if (!targetSlide) return;

		const slideLeft = targetSlide.offsetLeft;
		this.scroll_container.scrollTo({
			left: slideLeft,
			behavior: 'instant'
		});
	}
}

export default CustomSlider;
